import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { linkDiscord as linkDiscordRequest } from '@/services/userService'
import { ApiError } from '@/services/authService'

function LinkDiscordPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { user, refetchUser } = useAuth()
  const [error, setError] = useState<string>('')
  
  const discordId = searchParams.get('discordId')
  const username = searchParams.get('username')
  const returnUrl = searchParams.get('returnUrl') || '/profile'

  const [isLinking, setIsLinking] = useState(false)

  useEffect(() => {
    if (!user) {
      // Store the link info and redirect to login
      sessionStorage.setItem('pendingDiscordLink', JSON.stringify({
        discordId,
        username,
        returnUrl
      }))
      navigate('/login', { state: { from: window.location.pathname + window.location.search } })
      return
    }

    if (!discordId) {
      setError('Discord ID nebyl poskytnut')
      return
    }
  }, [user, discordId, navigate, returnUrl, username])

  const handleLink = async () => {
    if (!discordId) return

    setIsLinking(true)
    try {
      const response = await linkDiscordRequest(discordId)
      if (response.success) {
        await refetchUser()
        navigate(returnUrl)
      } else {
        setError(response.message)
      }
    } catch (err) {
      const message = err instanceof ApiError ? err.message : err instanceof Error ? err.message : 'Propojení se nepodařilo.'
      setError(message)
    } finally {
      setIsLinking(false)
    }
  }

  const handleCancel = () => {
    navigate(returnUrl)
  }

  if (!user) {
    return null
  }

  return (
    <div className="link-discord-page">
      <div className="container">
        <div className="link-container">
          <h1>Propojit Discord účet</h1>
          
          {error && (
            <div className="message error">
              {error}
            </div>
          )}

          <div className="discord-info">
            <h3>Discord účet k propojení:</h3>
            <div className="discord-details">
              <span className="discord-username">{username || 'Neznámý uživatel'}</span>
              <span className="discord-id">ID: {discordId}</span>
            </div>
          </div>

          <div className="current-user-info">
            <p>Propojit s účtem: <strong>{user.username}</strong></p>
          </div>

          <div className="link-actions">
            <button 
              className="btn-primary" 
              onClick={handleLink}
              disabled={isLinking}
            >
              {isLinking ? 'Propojování...' : 'Propojit účet'}
            </button>
            <button 
              className="btn-secondary" 
              onClick={handleCancel}
              disabled={isLinking}
            >
              Zrušit
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LinkDiscordPage
